export default __webpack_public_path__ + "static/media/ic_search_secondary.924cc0ca.svg";